document.addEventListener('DOMContentLoaded', function() {
  ProductCards.init();
});

const ProductCards = {
    selectors: {
      "swatchContainers": { selector: ".swatch-options", type: "all", scope: "document" },
      "swatchBtns": { selector: ".product-card .swatch-btn", type: "all", scope: "document" },
      "swatchSelects": { selector: ".product-card .swatch-btn-select", type: "all", scope: "document" },
      "addToCartBtns": { selector: ".product-card .add-to-cart-btn", type: "all", scope: "document" },
    },
  
    init: async function() { 
        Utility.fetchEls(this.selectors, this);
        this.initEventListeners();
        this.initOverflowSwatches();
        this.initCardVariants();
    },
  
    initEventListeners: function() {
      const {swatchBtns, swatchSelects, addToCartBtns } = this;

      if (swatchBtns) {
        swatchBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            Shared.handleSwatchChange(btn, false, true);
          });
        });
      }

      if (swatchSelects) {
        swatchSelects.forEach((select) => {
          select.addEventListener('change', () => {
            Shared.handleSwatchChange(select, false, true);
          });
        });
      }

      if (addToCartBtns) {
        addToCartBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            Cart.addToCart(event);
          });
        });
      }
    },

    initCardVariants: function() {
      if (typeof Shared === 'undefined') return;

      document.querySelectorAll('.product-card').forEach((card) => {
        const hasSwatches = card.querySelector('.swatch-btn, .swatch-btn-select');
        if (!hasSwatches) return;

        const oosBtn = card.querySelector('.quick-add.out-of-stock');
        const disabledSelectedSwatch = card.querySelector('.swatch-btn.selected.disabled');

        if (!oosBtn && !disabledSelectedSwatch) return;

        const firstAvailable =
          card.querySelector('button.swatch-btn:not(.disabled)') ||
          card.querySelector('.swatch-btn-select');

        if (firstAvailable) {
          Shared.handleSwatchChange(firstAvailable, false, true);
        }
      });
    },

    initOverflowSwatches: function() {
      const { swatchContainers } = this;
      if (!swatchContainers) return;
    
      swatchContainers.forEach((container) => {
        const cart = container.closest('#dropdown-cart');
        if ((!window.matchMedia('(max-width: 768px)').matches && !cart) || !container.closest('.product-card')) {
          return;
        }

        let cutoffNum = 4;
        // if (cart ) {
        //   cutoffNum = 4;
        // }
        const swatchBtns = Array.from(container.querySelectorAll('.swatch-btn'));
        if (swatchBtns.length > cutoffNum) {
          const overflowSwatches = Array.from(swatchBtns).slice(cutoffNum);
          const overflowContainer = document.createElement('div');
          overflowContainer.classList.add('overflow-swatches');
    
          overflowSwatches.forEach((swatch) => {
            overflowContainer.appendChild(swatch);
          });

          const overflowPlus = document.createElement('div');
          overflowPlus.classList.add('overflow-plus');
          overflowPlus.innerHTML = `+${overflowSwatches.length}`;
          overflowPlus.ariaLabel = 'View more swatches';
          overflowPlus.setAttribute('role', 'button');
          overflowPlus.setAttribute('tabindex', '0');
          overflowPlus.setAttribute('aria-expanded', 'false');
          overflowPlus.addEventListener('click', () => {
            overflowContainer.classList.toggle('active');
            overflowPlus.classList.toggle('active');
            const isActive = overflowContainer.classList.contains('active');
            overflowPlus.setAttribute('aria-expanded', isActive);
          });

          container.appendChild(overflowPlus);
    
          container.appendChild(overflowContainer);
        }
      });
    }
};